import type {
  BciBrand,
  BciCommune,
  BciProductInfoResponse,
  BciProposalResponse,
  BciQuotationResponse,
  BciQuoteMapping,
  BciRegion,
  BciVehicleDataResponse,
} from '../types/bciSegurosForm';
import baseApi from './baseApi';

interface BciQuotationEnrichedResponse extends BciQuotationResponse {
  leadId: number | null;
  clientId: number;
  quotes: BciQuoteMapping[];
}

interface BciProposalEnrichedResponse extends BciProposalResponse {
  policyId: number;
}

const bciSegurosApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    bciQuote: build.mutation<BciQuotationEnrichedResponse, Record<string, unknown>>({
      query: (body) => ({
        url: '/bci-seguros-veritas/quote',
        method: 'POST',
        body,
      }),
    }),
    bciGetVehicleData: build.mutation<BciVehicleDataResponse, { str_Patente: string }>({
      query: (body) => ({
        url: '/bci-seguros-veritas/vehicle-data',
        method: 'POST',
        body,
      }),
    }),
    bciCreateProposal: build.mutation<BciProposalEnrichedResponse, Record<string, unknown>>({
      query: (body) => ({
        url: '/bci-seguros-veritas/proposal',
        method: 'POST',
        body,
      }),
    }),
    bciGetBrandsModels: build.query<BciBrand[], void>({
      query: () => ({
        url: '/bci-seguros-veritas/brands-models',
      }),
    }),
    bciGetProductInfo: build.query<BciProductInfoResponse, void>({
      query: () => ({
        url: '/bci-seguros-veritas/product-info',
      }),
    }),
    bciGetRegions: build.query<BciRegion[], void>({
      query: () => ({
        url: '/bci-seguros-veritas/regions',
      }),
    }),
    bciGetCommunes: build.query<BciCommune[], { regionId: number }>({
      query: ({ regionId }) => ({
        url: `/bci-seguros-veritas/communes/${regionId}`,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useBciQuoteMutation,
  useBciGetVehicleDataMutation,
  useBciCreateProposalMutation,
  useBciGetBrandsModelsQuery,
  useBciGetProductInfoQuery,
  useBciGetRegionsQuery,
  useBciGetCommunesQuery,
} = bciSegurosApi;
